module.exports = {"361127100":"玉亭镇","361127101":"瑞洪镇","361127102":"黄金埠镇","361127104":"古埠镇","361127105":"乌泥镇","361127106":"石口镇","361127107":"杨埠镇","361127108":"九龙镇","361127109":"社赓镇","361127200":"康山乡","361127202":"东塘乡","361127204":"大塘乡","361127206":"鹭鸶港乡","361127207":"三塘乡","361127209":"洪家嘴乡","361127210":"白马桥乡","361127211":"江埠乡","361127213":"枫港乡","361127214":"大溪乡","361127217":"梅港乡","361127500":"渔池湖水产场","361127501":"县良种场","361127502":"李梅林场","361127503":"康山垦总场","361127504":"禾斛岭垦殖场","361127505":"峡山林场","361127506":"信丰垦殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361127.json
// module id = 1245
// module chunks = 0